import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Creare ofertă nouă',
  subtitle: 'Cum primește clientul un articol gratuit?',
  validation: {
    required: 'Vă rugăm să selectați un tip de ofertă',
  },
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Valoarea totală a comenzii',
      description: 'Ex. 10% reducere la comandă când cheltuiți 20 {{currency}}',
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      name: 'Articole selectate',
      description: 'Ex. 10% reducere la pizze de 30 cm.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      name: 'Articole selectate',
      description: 'Ex. 1 {{currency}} reducere la pizze de 30 cm.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Valoarea totală a comenzii',
      description: 'Ex. 1 {{currency}} reducere la comandă când cheltuiți 20 {{currency}}',
    },
    [OFFER_KIND.BOGO]: {
      name: 'Cumpără 1, primești 1 gratuit',
      description: 'Ex. Cumpără 1 pizza, primești altă pizza gratuit. Pizza mai ieftină este redusă.',
    },
    [OFFER_KIND.BOGO_HALF_PRICE]: {
      name: 'Cumpără 1, primești 1 la jumătate de preț',
      description: 'Ex. Cumpără 1 pizza, primești alta la jumătate de preț; pizza mai ieftină este redusă.',
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      name: 'Prin cumpărarea unui alt articol',
      description: 'Ex. Primești o băutură gratuită când comanzi un meniu.',
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      name: 'Prin cheltuirea unei sume fixe de {{currency}}',
      description: 'Ex. Primești un desert gratuit când cheltuiești 20 {{currency}}.',
    },
  },
};
